var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.searchText,
          expression: "searchText",
        },
      ],
      staticClass: "form-control",
      attrs: { type: "text", placeholder: "Номер телефона или заявка" },
      domProps: { value: _vm.searchText },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.searchText = $event.target.value
        },
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mt-1" },
      _vm._l(_vm.orders, function (o) {
        return _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body p-1" },
            [
              _c("div", { staticClass: "mb-0 flex justify-content-between" }, [
                _c(
                  "div",
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-xs btn-info mr-1",
                        on: {
                          click: function ($event) {
                            return _vm.openOrderToEdit(o.id)
                          },
                        },
                      },
                      [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
                    ),
                    _vm._v("\n            " + _vm._s(o.id) + "\n            "),
                    _c("OrderStatus", { attrs: { status: o.status } }),
                    _vm._v(" "),
                    _c("span", { staticClass: "badge badge-info" }, [
                      _vm._v(_vm._s(o.project_label)),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.selectedChat && !_vm.selectedChat.order_id
                  ? _c(
                      "div",
                      [
                        _c("LoadingButton", {
                          attrs: {
                            title: "Привязать к чату",
                            className: "btn btn-outline-success btn-xs",
                            onClick: () => _vm.linkChat(o.id),
                            loading: _vm.btnLoading,
                            color: _vm.$constants.SUCCESS_COLOR,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mb-0" }, [
                _vm._v("Планируемая доставка: "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.printDate(o.delivery_date, "DD.MM.YYYY"))),
                ]),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("стоимость заявки "),
                _c("span", { staticClass: "badge badge-success" }, [
                  _vm._v(_vm._s(o.price)),
                ]),
              ]),
              _vm._v(" "),
              _c("label", { staticClass: "text-muted" }, [_vm._v("Препараты")]),
              _vm._v(" "),
              _vm._l(o.details, function (d) {
                return _c(
                  "div",
                  { staticClass: "border-bottom p-1 mb-1 bg_light_gray" },
                  [
                    _c("p", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(d.drug.title) + " "),
                      _c("strong", [_vm._v("x " + _vm._s(d.qty))]),
                    ]),
                    _vm._v(" "),
                    _c("DrugStoreStatus", {
                      attrs: {
                        storeId: o.store_id,
                        storeStatus: _vm.storeStatus?.[d.drug.id]?.remain ?? {},
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "invoice_data" },
                      [
                        _vm._l(
                          _vm.getInvoicesToDivision(o.store_id, d.drug_id),
                          function (i) {
                            return [
                              _c("p", [
                                _vm._v("Накладная: "),
                                _c("strong", [_vm._v(_vm._s(i.id))]),
                                _vm._v(
                                  " (" +
                                    _vm._s(+i.qty) +
                                    "уп.) в дороге на " +
                                    _vm._s(
                                      _vm.printDate(i.delivery_date, "DD.MM")
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              !i.track
                                ? [
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v("не добавлен track номер!"),
                                      ]),
                                    ]),
                                  ]
                                : [
                                    (i.extra_data?.flippost?.info ?? []).length
                                      ? [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                i.extra_data.flippost.info[0]
                                                  .scity
                                              ) +
                                                " - " +
                                                _vm._s(
                                                  i.extra_data.flippost.info[0]
                                                    .rcity
                                                )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          i.extra_data.flippost.info[0].dod
                                            ? [
                                                _c("p", [
                                                  _vm._v(
                                                    "Накладная доставлена (ТК):\n                      "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.printDateByFormat(
                                                          i.extra_data.flippost
                                                            .info[0].dod
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ]
                                            : [
                                                _c("p", [
                                                  _vm._v(
                                                    "Планируемая дата доставки (ТК):\n                      "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.printDateByFormat(
                                                          i.extra_data.flippost
                                                            .info[0].dtd
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ],
                                        ]
                                      : [_c("p", [_vm._v("Нет данных c ТК!")])],
                                    _vm._v(" "),
                                    i.extra_data?.flippost?.updated_at
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "text-muted text-right",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.printDate(
                                                    i.extra_data.flippost
                                                      .updated_at,
                                                    "DD.MM.YYYY HH:mm",
                                                    false,
                                                    1
                                                  )
                                                )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                            ]
                          }
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }